import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";

const restaurantName = process.env.REACT_APP_RESTAURANT_NAME;
const colorBackground = process.env.REACT_APP_BACKGROUND_COLOR;
const siteMedSrc = process.env.REACT_APP_MEDIA_SRC;
const businessHoursLine1 = process.env.REACT_APP_BUSINESSHOURS_LINE1;
const businessHoursLine2 = process.env.REACT_APP_BUSINESSHOURS_LINE2;
const businessHoursLine3 = process.env.REACT_APP_BUSINESSHOURS_LINE3;
const businessHoursLine4 = process.env.REACT_APP_BUSINESSHOURS_LINE4;
const textColor = process.env.REACT_APP_TEXT_COLOR;

export default function BusinessCard() {
  return (
    <Card>
      <CardActionArea
        className="color-scheme"
        sx={{ cursor: "default !important", pointerEvents: "none", backgroundColor: colorBackground }}
      >
        <CardMedia
          component="img"
          height="140px"
          image={siteMedSrc + "business-hours" + ".png"}
          title={`${restaurantName} Store Hours`}
          alt={`${restaurantName} Store Hours`}
          width="100%"
          loading="lazy"
        />
        <CardContent
          style={{ color: textColor, height: "200px" }}
        >
          <Typography variant="h4" component="div">
            Store Hours
          </Typography>
          <Typography variant="h6" component="div">
            {businessHoursLine1}
            <br></br>
            {businessHoursLine2}
            <br></br>
            {businessHoursLine3}
            <br></br>
            {businessHoursLine4}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
